import { render } from "./MenuCategoryList.vue?vue&type=template&id=1a985a52"
import script from "./MenuCategoryList.vue?vue&type=script&lang=js"
export * from "./MenuCategoryList.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__